(function ($) {
	$(document).ready(function () {
		setTimeout(setUpForms, 300);
	});

	function setUpForms() {
		const $formContainer = $('.pledge-progress-form');

		if (!$formContainer.length) {
			return;
		}

		$formContainer.each(setUpFormListeners);
	}

	function setUpFormListeners() {
		const $form = $(this);
		const $submit = $form.find('input[type="button"]');

		$submit.on('click', timeCheckValidSubmission($form));
	}

	function timeCheckValidSubmission($form) {
		return function () {
			setTimeout(checkValidSubmission($form), 500);
		};
	}

	function checkValidSubmission($form) {
		return function () {
			const $errors = $form.find('.nf-error-msg');
			if (!$errors.length) {
				// no errors!
				setTimeout(updateCounter($form), 500);
				return;
			}
		};
	}

	function updateCounter($form) {
		return function () {
			const id = `js-pledged-form-${$form.data('form-id')}`;
			const $target = $(`#${id}`);
			const scrollTop = $target.offset().top - 80;

			$('html, body').stop().animate({ scrollTop }, 500, 'swing', updateStats($form));
		};
	}

	function updateStats($form) {
		return function () {
			$.get(`./?time=${new Date().valueOf()}`, function (res) {
				const $html = $(res);
				const formId = $form.data('form-id');
				const id = `js-pledged-form-${formId}`;

				if (typeof window.runCountUp === 'undefined') {
					// no count up animation, just swap the html
					$(`#${target}`).html($html.find(`#${id}`).html());
					return;
				}

				const newPledged = $html.find(`#js-pledged-form-pledged-${formId}`).data('count-end');
				const newPercentage = $html.find(`#js-pledged-form-percentage-${formId}`).data('count-end');
				const scaleX = Math.min(1, newPercentage / 100);

				$form.find(`#js-pledged-form-pledged-${formId}`).data('count-end', newPledged);
				$form.find(`#js-pledged-form-percentage-${formId}`).data('count-end', newPercentage);
				$form.find('.pledge-progress__bar').css({ transform: `scaleX(${scaleX})` });
				window.runCountUp();
			});
		};
	}
})(jQuery);
